module.exports = __webpack_public_path__ + "img/homenavlogo.9a910dad.png";